import React, { useEffect, useState } from 'react';
import { Form } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom'
import { _beginformState as _beginformStorage } from '../_states/_beginformState';
import { _aboutyouState as _aboutyouStorage } from '../_states/_aboutyouState';
import { _detailState as _detailStorage } from '../_states/_detailState';
import { _reasonForReferralState as _reasonForReferralStorage } from '../_states/_reasonForReferralState';
import postData from '../Services/_post-data-service';
import { config } from '../Services/_config';
import { _resetState } from '../_states/_resetState';
import { _regularExpressions } from '../Services/_regularExpressions';
import LoadingSpinner from '../helpers/_Loading';

function Submit(props) {
  //Regex for all spaces globally in the variable applied to
  // const spaceRegex = new RegExp("\\s", "g");
  const [isLoading,setIsLoading] = useState(false);
  const [showResubmitSection, setShowResubmitSection] = useState(false);
  const emptyString = "";

  const formObjects = {
    beginForm: {
      utrn: _beginformStorage.getUtrn(),
      confirm: _beginformStorage.getConfirm()
    },
    aboutYou: {
      foreName: _aboutyouStorage.getForeName(),
      surName: _aboutyouStorage.getSurName(),
      contact: _aboutyouStorage.getContact().replace(_regularExpressions.spacePattern,emptyString),
      email: _aboutyouStorage.getEmail(),
      organisation: _aboutyouStorage.getOrganisation(),
      department: _aboutyouStorage.getDepartment(),
      teamContact: _aboutyouStorage.getTeamContact(),
      chkConsent: _aboutyouStorage.getChkConsent(),
      // to keep the object clean & lightweight, cleared field contents before submission based on business logic
      consentText: _aboutyouStorage.getChkConsent() === "no" ? _aboutyouStorage.getConsentText() : emptyString
    },
    details: {
      foreName: _detailStorage.getForeName(),
      surName: _detailStorage.getSurName(),
      gender: _detailStorage.getGender(),
      dob: _detailStorage.getDob(),
      dobDay: _detailStorage.getDobDay(),
      dobMonth: _detailStorage.getDobMonth(),
      dobYear: _detailStorage.getDobYear(),
      approximateAge: _detailStorage.getApproximateAge(),
      addressYesOrNo: _detailStorage.getAddressYesOrNo(),
      addressUPRN: _detailStorage.getAddressUPRN(),
      // postCode is not required by the submission lambda
      //postCode: _detailStorage.getAddressYesOrNo() === "yes" ? _detailStorage.getPostCode() : emptyString ,
      // to keep the object clean & lightweight, cleared field contents before submission based on business logic
      ddlAddress: _detailStorage.getAddressYesOrNo() === "yes" ? _detailStorage.getDdlAddress() : emptyString ,
      // to keep the object clean & lightweight, cleared field contents before submission based on business logic
      addressDetail: _detailStorage.getAddressYesOrNo() === "no" ? _detailStorage.getAddressDetail() : _detailStorage.getIsAddressInLeeds() === "yes" ? _detailStorage.getManualAddressInput() : _detailStorage.getPersonAddressInfo(),
      emailYesOrNo: _detailStorage.getEmailYesOrNo(),
      // to keep the object clean & lightweight, cleared field contents before submission based on business logic
      personsEmail: _detailStorage.getEmailYesOrNo() === "yes" ? _detailStorage.getPersonsEmail() : emptyString ,
      mainContactYesOrNo: _detailStorage.getMainContactYesOrNo(),
      // to keep the object clean & lightweight, cleared field contents before submission based on business logic
      personsMainContactNo: _detailStorage.getMainContactYesOrNo() === "yes" ? _detailStorage.getPersonsMainContactNo().replace(_regularExpressions.spacePattern,emptyString): emptyString ,
      alternateContactYesOrNo: _detailStorage.getAlternateContactYesOrNo(),
      // to keep the object clean & lightweight, cleared field contents before submission based on business logic
      alternateContactNo: _detailStorage.getAlternateContactYesOrNo() === "yes" ? _detailStorage.getAlternateContactNo().replace(_regularExpressions.spacePattern,emptyString) : emptyString ,
      // to keep the object clean & lightweight, cleared field contents before submission based on business logic
      alternateContactNoDetail: _detailStorage.getAlternateContactYesOrNo() === "yes" ? _detailStorage.getAlternateContactNoDetail() : emptyString ,
      nhsNumber: _detailStorage.getNhsNumber().replace(_regularExpressions.spacePattern,emptyString),
      ethnicOrigin: _detailStorage.getEthnicOrigin(),
      languageSpoken: _detailStorage.getLanguageSpoken(),
      interpreter: _detailStorage.getInterpreter(),
      communicationNeeds: _detailStorage.getCommunicationNeeds(),
      // to keep the object clean & lightweight, cleared field contents before submission based on business logic
      communicationNeedsDetail: _detailStorage.getCommunicationNeeds() === "yes" ? _detailStorage.getCommunicationNeedsDetail() : emptyString ,
      healthConditions: _detailStorage.getHealthConditions()
    },
    reasonforReferral: {
      mainTypeSupport: _reasonForReferralStorage.getMainTypeSupport(),
      contactInformationAround: _reasonForReferralStorage.getContactInformationAround(),
      detailsOfDisabilities: _reasonForReferralStorage.getDetailsOfDisabilities(),
      riskToStaff: _reasonForReferralStorage.getRiskToStaff(),
      // to keep the object clean & lightweight, cleared field contents before submission based on business logic
      riskDetails: _reasonForReferralStorage.getRiskToStaff() === "yes" ? _reasonForReferralStorage.getRiskDetails() : emptyString ,
      whatWillHappenNext: _reasonForReferralStorage.getWhatWillHappenNext(),
      involvedOrganisationOrProfession: _reasonForReferralStorage.getInvolvedOrganisationOrProfession(),
      // to keep the object clean & lightweight, cleared field contents before submission based on business logic
      organisationDetails: _reasonForReferralStorage.getInvolvedOrganisationOrProfession() === "yes" ? _reasonForReferralStorage.getOrganisationDetails() : emptyString,
      files: _reasonForReferralStorage.getFiles()
    }
  };

  // scroll to the top
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [])

  const navigate = useNavigate();

  const onSubmit = event => {
    event.preventDefault();

    setIsLoading(true);
    _resetState.setResetState(false);

    postData({ path: config.postSubmitPath, data: JSON.stringify(formObjects) }).then(result => {
      const { httpStatus, error } = result.responseData;
      console.log(httpStatus);
      if(httpStatus === 200) {
        setShowResubmitSection(false);
        navigate('/confirm');
      } else {
        console.log({"error":error});
        setShowResubmitSection(true);
      }
      setIsLoading(false);
    });


  };

  return (
    <Form className="input-form" onSubmit={onSubmit}>
      <main id="main" className="sectionOne">
				<div className="container-fluid">
          <div className="row">
            <div className="col-md-8">
              <div className="tab-content" id="myTabContent">
                <div className="tab-pane fade show active" id="home" role="tabpanel" aria-labelledby="home-tab">
                  { isLoading && <LoadingSpinner isLoading={isLoading} /> }

                  <h2>Submit form for consideration</h2>
                  <p>If you want to check the information you’ve provided before you submit the Adult Social Care referral form, simply use the previous/next buttons at the bottom of the page.</p>

                  { showResubmitSection &&
                    <div role="status" aria-labelledby="SubmitError" className="text-highlight text-highlight--red">
                        <h2 id="SubmitError">Error on submit</h2>
                        <p>There was an error on submitting your form. Please wait a couple of minutes and try again. If you keep having this problem, please send an email to <a href="mailto:ascformfeedback@leeds.gov.uk?subject=Leeds ASC Referral form problem">ascformfeedback@leeds.gov.uk</a> </p>
                    </div>
                  }

									<div className="form-group form-group--progbuttons">
                    <button className="btn  btn-light btn-lg" type="button"
                      onClick={(event) => {
                        event.preventDefault();
                        navigate('/reason-for-referral');
                      }}
                    >Previous</button>
                    <button className="btn btn-primary btn-lg" type="submit">Submit application form</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
    </Form>
  );
};
export default Submit;
